module.exports = __webpack_public_path__ + "img/productSatellite_18.d346ebfc.png";